<div class="main-db gap-top">
  <div class="container-fluid mt-2">
    <form class="row" [formGroup]="form">
      <div class="col-12">
        <h1>{{ title }}</h1>
      </div>
      <div class="col-sm-1 col-6 pr-0 mt-2 mt-sm-0">
        <input
          type="text"
          class="form-control form-control-sm input-custom"
          formControlName="numberPlate"
          placeholder="License Plate"
          minlength="4"
          maxlength="8"
        />
      </div>
      <div class="col-sm-3 col-6 pr-sm-0 pr-3 mt-2 mt-sm-0">
        <input
          type="text"
          matInput
          class="form-control form-control-sm pl-2 mt-0"
          ngxDaterangepickerMd
          [locale]="{ format: 'YYYY-MM-DD HH:mm:ss' }"
          startKey="start"
          endKey="end"
          [(ngModel)]="selected"
          [ngModelOptions]="{standalone: true}"
          [timePicker]="true"
          [timePickerSeconds]="true"
          [timePickerIncrement]="10"
          [timePicker24Hour]="true"
          [showCustomRangeLabel]="false"
          [alwaysShowCalendars]="true"
          [linkedCalendars]="true"
          name="daterange"
          placeholder="Start & End Time"
          autocomplete="off"
          [ranges]="ranges"
        />
      </div>
      <div class="col-sm-2 col-6 pr-0 mt-2 mt-sm-0">
        <select
          class="form-control form-control-sm input-custom"
          formControlName="serviceName"
          placeholder="Service Name"
          (change)="onPaymentServesChange($event.target.value)"
        >
          <option value="">Select Payment</option>
          <option value="Parkmobile">Parkmobile</option>
          <option value="Flowbird">Flowbird</option>
          <option value="Permitted">Passport</option>
        </select>
      </div>
      <div class="col-sm-2 col-6 pr-0 mt-2 mt-sm-0">
        <select class="form-control form-control-sm input-custom"
          formControlName="zone"
        >
          <option value="" disabled="true">Select Zone</option>
            <option
            *ngFor="let zoneObject of selectedServiceZones"
            [value]="zoneObject.zoneId"
          >
            {{ zoneObject.zoneName }} - {{ zoneObject.zoneId }}
          </option>
        </select>
        <!-- <select *ngIf="selectedServiceName != 'Flowbird'"
          class="form-control form-control-sm input-custom"
          formControlName="zone"
        >
          <option value="" disabled="true">Select Zone</option>
            <option
            *ngFor="let zoneObject of selectedServiceZones"
            [value]="zoneObject.zoneId"
          >
            {{ zoneObject.zoneName }} - {{ zoneObject.zoneId }}
          </option>
        </select>
        <select *ngIf="selectedServiceName === 'Flowbird'"
          class="form-control form-control-sm input-custom"
          formControlName="zone"
        >
          <option value="" disabled="true">Select Zone</option>
            <option
            *ngFor="let zoneObject of selectedServiceZones"
            [value]="zoneObject.zoneName"
          >
            {{ zoneObject.zoneName }} - {{ zoneObject.zoneId }}
          </option>
        </select> -->
      </div>
      <div class="col-sm-4 col-12 ml-auto mt-2 mt-sm-0">
        <button
          class="btn btn-sm btn-success float-left"
          (click)="addLPNWithPayment()"
        >
          <i class="fas fa-plus mr-1"></i> Add
        </button>

        <button
          class="btn btn-sm btn-success float-left ml-2"
          (click)="resetForm()"
        >
          <i class="fa fa-refresh mr-1"></i> Clear
        </button>

        <button
          class="btn btn-sm btn-success float-left ml-2"
          (click)="fileUploaderDialog()"
        >
          <i class="fas fa-save mr-1"></i> Upload CSV
        </button>
      </div>
    </form>
  </div>

  <div class="container-fluid mt-2">
    <div class="row">
      <div class="col-xl-12">
        <div class="db-block table-responsive" style="height: auto !important">
          <i class="fa fa-database mr-2" aria-hidden="true"></i>
          <span>{{ title }}</span>
          <a type="button" class="float-right" (click)="excelSheetDownload()">
            <i class="fa fa-download mr-1" aria-hidden="true"></i> Export CSV
          </a>
          <a type="button" class="float-right mr-2" (click)="sampleCSV()">
            <i class="fa fa-download mr-1" aria-hidden="true"></i> Sample CSV
          </a>

          <table
            mat-table
            [dataSource]="dataSource"
            class="gridData mt-2"
            matSort
          >
            <ng-container matColumnDef="numberPlate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                License Plate
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.data.numberPlate }}
              </td>
            </ng-container>

            <ng-container matColumnDef="paymentServiceName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Payment Service Name
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.data.paymentServiceName }}
              </td>
            </ng-container>

            <ng-container matColumnDef="startTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Start Date Time
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.data.startTime | date : "y-MM-dd HH:mm:ss.SSS" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="endTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                End Date Time
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.data.endTime | date : "y-MM-dd HH:mm:ss.SSS" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="zone">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Zone</th>
              <td mat-cell *matCellDef="let element">
                <span
                  *ngIf="
                    getZoneName(element.data.zoneNumber) == 'Zone Deleted!'
                  "
                  class="badge badge-danger"
                  >{{
                    element.data.zoneName != null
                      ? element.data.zoneName
                      : getZoneName(element.data.zoneNumber)
                  }}</span
                >
                <span
                  *ngIf="
                    getZoneName(element.data.zoneNumber) != 'Zone Deleted!'
                  "
                  >{{
                    element.data.zoneName != null
                      ? element.data.zoneName
                      : getZoneName(element.data.zoneNumber)
                  }}</span
                >
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
          <mat-paginator [pageSizeOptions]="[10, 25]"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
